import arAnchorPhoto from '../../../../docs/ar-anchor-photo-brief.md?raw';
import attractionWriting from '../../../../docs/attraction-writing-guide.md?raw';
import contentOps from '../../../../docs/content-ops.md?raw';
import questModeration from '../../../../docs/quest-moderation-guide.md?raw';
import questTemplates from '../../../../docs/quest-templates-scalable.md?raw';
import questWriting from '../../../../docs/quest-writing-guide.md?raw';
import routeWriting from '../../../../docs/route-writing-guide.md?raw';
import spbAttractionEditing from '../../../../docs/spb-attraction-editing-brief.md?raw';

export type WikiGroup = 'moderation' | 'writing' | 'ops';

export type WikiArticle = {
    slug: string;
    /** Source filename without path, used to remap relative .md links */
    file: string;
    titleKey: string;
    summaryKey: string;
    group: WikiGroup;
    markdown: string;
};

export const WIKI_GROUP_ORDER: WikiGroup[] = ['moderation', 'writing', 'ops'];

export const WIKI_ARTICLES: WikiArticle[] = [
    {
        slug: 'quest-moderation',
        file: 'quest-moderation-guide.md',
        titleKey: 'questModeration',
        summaryKey: 'questModeration',
        group: 'moderation',
        markdown: questModeration,
    },
    {
        slug: 'quest-writing',
        file: 'quest-writing-guide.md',
        titleKey: 'questWriting',
        summaryKey: 'questWriting',
        group: 'writing',
        markdown: questWriting,
    },
    {
        slug: 'attraction-writing',
        file: 'attraction-writing-guide.md',
        titleKey: 'attractionWriting',
        summaryKey: 'attractionWriting',
        group: 'writing',
        markdown: attractionWriting,
    },
    {
        slug: 'route-writing',
        file: 'route-writing-guide.md',
        titleKey: 'routeWriting',
        summaryKey: 'routeWriting',
        group: 'writing',
        markdown: routeWriting,
    },
    {
        slug: 'spb-attraction-editing',
        file: 'spb-attraction-editing-brief.md',
        titleKey: 'spbAttractionEditing',
        summaryKey: 'spbAttractionEditing',
        group: 'writing',
        markdown: spbAttractionEditing,
    },
    {
        slug: 'quest-templates',
        file: 'quest-templates-scalable.md',
        titleKey: 'questTemplates',
        summaryKey: 'questTemplates',
        group: 'writing',
        markdown: questTemplates,
    },
    {
        slug: 'content-ops',
        file: 'content-ops.md',
        titleKey: 'contentOps',
        summaryKey: 'contentOps',
        group: 'ops',
        markdown: contentOps,
    },
    {
        slug: 'ar-anchor-photo',
        file: 'ar-anchor-photo-brief.md',
        titleKey: 'arAnchorPhoto',
        summaryKey: 'arAnchorPhoto',
        group: 'ops',
        markdown: arAnchorPhoto,
    },
];

const bySlug = new Map(WIKI_ARTICLES.map((a) => [a.slug, a]));
const byFile = new Map(WIKI_ARTICLES.map((a) => [a.file, a.slug]));

export const getWikiArticle = (slug: string | undefined) =>
    (slug ? bySlug.get(slug) : undefined) ?? undefined;

/** Map `./quest-writing-guide.md` / `quest-writing-guide.md` → wiki slug, if known. */
export const wikiSlugForMdHref = (href: string): string | undefined => {
    const trimmed = href.trim();
    if (!trimmed || trimmed.startsWith('http') || trimmed.startsWith('#')) {
        return undefined;
    }
    const file = trimmed.replace(/^\.\//, '').split('#')[0];
    if (!file.endsWith('.md')) return undefined;
    return byFile.get(file);
};
